import type {
	HTTPValidationError,
	SetCurrentUserPreferenceParams,
	SetCurrentUserPreferenceRequestModel,
} from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const usePreferenceMutation = (
	params: SetCurrentUserPreferenceParams,
	options?: UseMutationOptions<
		void,
		AxiosError<HTTPValidationError>,
		SetCurrentUserPreferenceRequestModel
	>
) =>
	useMutation<
		void,
		AxiosError<HTTPValidationError>,
		SetCurrentUserPreferenceRequestModel
	>({
		mutationFn: (data) => client.users.setCurrentUserPreference(params, data),
		...(options || {}),
	})

export const usePreferencesMutation = (
	options?: UseMutationOptions<
		void,
		AxiosError<HTTPValidationError>,
		SetCurrentUserPreferenceRequestModel
	>
) =>
	useMutation<
		void,
		AxiosError<HTTPValidationError>,
		SetCurrentUserPreferenceRequestModel
	>({
		mutationFn: (data) => client.users.setCurrentUserPreferences(data),
		...(options || {}),
	})
